<div class="appt-verify-body customer-font-{{company?.appsettings?.customerPreviewFontSize}}">
  <div class="verfication-card">
    <!-- First Header unpaid -->
    <div class="appt-preview-header level-1-bg">
      <div class="header-wrapper level-1" [ngClass]="company?.name?.length >= 74 ? 'long-character-name' : ''">
        <div class="logo">
          <div class="logo-placehonder verticalWrapper">
            <div class="verticalCenter">
              <div class="company-presence">
                <div class="logoImgWrapper">
                  <img [src]="company.logo" *ngIf="company.logo" class="img-fluid">
                </div>
                <div class="logo-title">
                  {{company.name}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="communication">
          <div class="icon-box verticalWrapper">
            <div class="globe-icon" (click)="toggleLanguageDropdown()" *ngIf="companyLocalization">
              <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
              <span class="lang">
                {{currentLang?.toUpperCase()}}
              </span>
              <div *ngIf="isLanguageDropdownVisible" class="language-dropdown">
                <div (click)="switchLanguage('en')">
                  English
                </div>
                <div (click)="switchLanguage('fr')">
                  French (Français)
                </div>
              </div>
            </div>
            <div class="verticalCenter">
              <a class="order-action" [href]="'tel:'+ company.phone">
                <i class="fal fa-phone-alt font-16 mr-15 pointer" tooltipPosition="top"
                  [pTooltip]="company.phone | mask: '(000) 000-0000'"></i>
              </a>

              <a class="order-action" [href]="'mailto:'+ company.email">
                <i class="fal fa-envelope font-16 pointer"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="verfication-card-body flex-column flex-center-center">
      <div class="verfication-card-body-content">
        <div class="calendar-img text-center">
          <img *ngIf="status === 'confirmed'" src="../../../../assets/img/confirm-appt.svg" alt="Confirm Appointment">
          <img *ngIf="status === 'cancelled'" src="../../../../assets/img/cancelled-appt.svg"
            alt="Canceled Appointment">
        </div>
        <div class="verification-title dynamicFont font-600 mb-2 text-center">{{title}}</div>
        <div [innerHTML]="message" class="verification-content dynamicFont font-gray-45 text-center">
        </div>
        <div [hidden]="!feedback" [innerHTML]="feedback" class="verification-feedback dynamicFont text-center">
        </div>
      </div>
    </div>
    <div class="verificaton-footer flex-column flex-center-center dynamicFont">
      <p class="m-0 text-center">&copy; {{company.name}}, {{year}}. {{'unsubscribe.all-rights-reserved'|translate}}</p>
      <p class="m-0 text-center">{{'unsubscribe.powered-by' | translate}} <a class="website-link"
          href="http://autoleap.com/">AutoLeap</a> </p>
    </div>
  </div>
</div>